module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', [_c('div', {
    staticClass: "area-chart"
  }, [_c('h1', [_vm._v("Example Area Chart")]), _vm._v(" "), _c('area-chart', {
    attrs: {
      "data": _vm.data,
      "width": _vm.chartWidth,
      "height": 300,
      "max": _vm.max
    },
    on: {
      "select": _vm.onSelect
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h3', [_vm._v("Selected Value: " + _vm._s(_vm.currentValue))]), _vm._v(" "), _c('div', [_c('label', [_vm._v("Record Count: ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model:value",
      value: (_vm.itemCount),
      expression: "itemCount",
      arg: "value"
    }],
    domProps: {
      "value": _vm._s(_vm.itemCount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.itemCount = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('label', [_vm._v("Min Value: ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model:value",
      value: (_vm.min),
      expression: "min",
      arg: "value"
    }],
    domProps: {
      "value": _vm._s(_vm.min)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.min = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('label', [_vm._v("Max Value: ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model:value",
      value: (_vm.max),
      expression: "max",
      arg: "value"
    }],
    domProps: {
      "value": _vm._s(_vm.max)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.max = $event.target.value
      }
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-24a88232!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Demo.vue
// module id = 71
// module chunks = 2